import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  #header-sticky {
    position:sticky;
    z-index: 20;
    top: 0px;
  }

  #root {
    min-height: 100vh;
    position: relative;
    z-index: 10;
    background-color: white;
  }

  #modal {
    position: relative;
    z-index: 40;
  }

  #snackbar {
    position: relative;
    z-index: 50;
  }

  #sidebar {
    position: relative;
    z-index: 30;
  }

  #footer-sticky {
    position:sticky;
    z-index: 20;
    bottom: 0px;
  }
`;

export const Layout = styled("div") <{ sidebarOpened: boolean }>``;

export const Content = styled("main")`
  overflow: auto;
`;

export const SubHeader = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.White};
  padding: 20px 35px;
  background: #e9edf2;
  border-bottom: 1px solid #dee2e8;
`;
